import styles from '../css/SkeletonCard.module.css';

const SkeletonCard = () => (
  <div className={styles.skeletonWrapper}>
    <div className={styles.skeletonImage} />
    <div className={styles.skeletonTitle} />
    <div className={styles.skeletonTitleShort} />
    <div className={styles.skeletonMeta} />
  </div>
);

export default SkeletonCard;
